<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'uploadfile',
})
</script>
<template>
  <a-upload
      v-model:file-list="fileList"
      :action="action"
      accept=".doc,.docx,.pdf,.xls,.xlsx,.csv,.ppt"
      :maxCount="1"
      :data="props.data"
      @change="change"
    >
      <div class="round flex flex-column align-center radius-sm pointer padding-sm text-gray" style="border:1px solid #afafaf">
        <plus-outlined />
        <div style="margin-top: 8px">上传文件</div>
      </div>
    </a-upload>
</template>
<script setup lang="ts" name="uploadfile">
import { PlusOutlined } from '@ant-design/icons-vue'
import { ref,defineEmits,defineProps,watch,onMounted } from 'vue'
import { baseURL } from '@/utils/util'
import type { UploadProps } from 'ant-design-vue'
  const props=defineProps({
      value:{type:String},
      data:{type:Object}
  })
  const first=ref<boolean>(true)
  const action=ref<string>(baseURL+'/Upload/UploadWangEditor')
  const fileList=ref<UploadProps['fileList']>([])
  const emits= defineEmits(['update:value'])
  const change=(f:any)=>{
    fileList.value=f.fileList
    if(f.fileList.length>0){
      var r=f.fileList[0]
      if(r.status=='done'&&r.response&&r.response.code==0){
        var file:String=''
        if(Array.isArray(r.response.data)){
            file=r.response.data[0].href
        }else{
            file=r.response.data.href
        }
        emits('update:value',file)
      }
    }

  }
  onMounted(()=>{
    if(props.value){
      var list=[{
          name:props.value,
          url:baseURL+props.value,
          thumbUrl:baseURL+props.value,
          status:'done',
          response:{code:0,data:{url:baseURL+props.value,href:props.value}}
        }]
      fileList.value=list
      }
  })

</script>
<style lang="less">
  .ant-upload-list-item{padding:8px 0;}
</style>
